// Per-environment public app URL. Single source for server-side APP_URL values (config.*.ts) and
// the build-time client NEXT_PUBLIC_APP_URL (next.config.ts). No `server-only` import:
// next.config.ts runs in plain Node and would throw on one.
//
// Used to carry both apps' URLs (the Docmersion <-> ACR Studio switch links) before ACR Studio was
// folded into this app and decommissioned (DOC-262) — kept as a Record-of-envs rather than a flat
// map now that there's only one key, since callers already destructure `.docmersion` off it.
export const APP_URLS: Record<"dev" | "prod", { docmersion: string }> = {
  dev: { docmersion: "http://localhost:3001" },
  prod: { docmersion: "https://app.accessibilityforall.com" },
};

export type AppEnv = keyof typeof APP_URLS;

// Per-environment base URL of the public Lambda API (apps/lambda). The embed widget bakes one of
// these in at build time; dev is serverless offline (`npm run dev:offline -w @docmersion/lambda`).
export const API_URLS: Record<AppEnv, string> = {
  dev: "http://localhost:3000",
  prod: "https://api.docmersion.com",
};
